import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { VTextField } from 'vuetify/lib'

import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import VCurrencyField from 'v-currency-field'
import { VueMaskDirective } from 'v-mask'
import VStripeElements from 'v-stripe-elements/lib'

Vue.config.productionTip = false

Vue.use(VuetifyGoogleAutocomplete, {apiKey: process.env.VUE_APP_GOOGLE_MAPS_API_KEY});
Vue.use(VStripeElements)
Vue.use(require('vue-moment'));
Vue.use(require('vuebar'));

Vue.component('v-text-field', VTextField)
Vue.use(VCurrencyField, { 
  locale: 'en-US',
  currency: "USD",
	decimalLength: 2,
	autoDecimalMode: false,
	min: null,
	max: null,
  valueAsInteger: true,
  allowNegative: false
})

Vue.directive('mask', VueMaskDirective);

Vue.filter('listToString', function (value) {
  let string = null
  value.forEach((item) => {
    if (string === null) {
      string = item.name
    } else {
      string += `, ${item.name}`
    }
  })
  return string
})

Vue.filter("capitalize", function (value) {
  if (!value) 
      return '';
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
});


new Vue({
  router,
  store,
  vuetify,
  mounted() {
    document.title = this.$store.state.applicationTitle;
  },
  render: h => h(App)
}).$mount('#app')
